<div class="card-top-image">
    <div class="card-image">
      <img [src]="cardInfo.imageUrl" alt="" class="card-big-footer-image">
    </div>
    <div class="card-footer card-big-footer">
        <h2 class="webapp-title-secondary">{{cardInfo.title}}</h2>
        <p>{{cardInfo.text}}</p>
        
        <button (click)="callToActionButton()" *ngIf="isStatus('unpaid')" class="button button-fill button-round btn-premium">
            <i class="fa-solid fa-crown"></i>  
            {{cardInfo.cta}}
        </button>

        <div *ngIf="isStatus('processing')" class="loading-overlay center"> <!-- -->
            <div class="spinner"></div>
            <p>Procesando orden...</p>
        </div>

        <div *ngIf="isStatus('posponed')" class="loading-overlay center"> <!-- -->
            <div class="spinner"></div>
            <p>Añadiremos esta guía a tu carrito...</p>
        </div>

        <div *ngIf="isStatus('paymentPending')" class="payment-pending-card">
            <button  mat-icon-button class="pending-icon circle-icon"> <!-- *ngIf="isStatus('paid')" -->
                <mat-icon mat-icon-button>hourglass_empty</mat-icon>
            </button>
            
            <h3>Payment Pending</h3>
            <p>We are waiting to confirm your bank transfer.</p>
            <p>Once confirmed, we will activate your premium content.</p>
            <p><strong>Estimated processing time: 1-3 business days.</strong></p>
        </div>
          
        
        <!-- <p>Estado:{{status}}</p> -->

    </div>
</div>

